// extracted by mini-css-extract-plugin
export default {"col":"dPLgg","wrapperMedium":"sII0N","wrapperBig":"s6CNh","grid":"TAYAq"};